const gqlHost = process.env.REACT_APP_GQL_HOST || 'findy.minisuomi.fi'
const authHost = process.env.REACT_APP_AUTH_HOST || 'findy.minisuomi.fi'
const httpScheme = process.env.REACT_APP_HTTP_SCHEME || 'https'
const wsScheme = process.env.REACT_APP_WS_SCHEME || 'wss'

const config = {
  wsUrl: `${wsScheme}://${gqlHost}`,
  gqlUrl: `${httpScheme}://${gqlHost}`,
  authUrl: `${httpScheme}://${authHost}`,
}

export default config
